var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf-add-exam" }, [
    _c(
      "div",
      { staticClass: "add-header" },
      [
        _c("span", { staticClass: "add-item add-btn" }, [_vm._v("+ 新增试卷")]),
        _c(
          "el-form",
          {
            ref: "examForm",
            attrs: {
              "label-width": "100px",
              rules: _vm.rules,
              model: _vm.exam,
            },
          },
          [
            _c(
              "el-form-item",
              { staticClass: "add-item", attrs: { label: "试卷分类" } },
              [_vm._v(" " + _vm._s(_vm.exam.types.text) + " ")]
            ),
            _c(
              "el-form-item",
              {
                staticClass: "add-item add-exam-name",
                attrs: { label: "试卷名称", prop: "name" },
              },
              [
                _c("el-input", {
                  model: {
                    value: _vm.exam.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.exam, "name", $$v)
                    },
                    expression: "exam.name",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("span", { staticClass: "add-item last" }, [
          _vm._v(" 试卷总分 "),
          _c("span", { staticClass: "total" }, [
            _vm._v(_vm._s(_vm.totalScore)),
          ]),
          _vm._v(" 分 "),
          _c("span", { staticClass: "tip" }, [_vm._v("(自动计算)")]),
        ]),
        _c(
          "DsfButton",
          {
            staticClass: "save-btn",
            attrs: { title: "保存", disabled: _vm.disabled, icon: "baocun" },
            on: { click: _vm.savePaper },
          },
          [_vm._v(" 保存 ")]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "questions-area" }, [
      _c(
        "div",
        { staticClass: "info-board" },
        [
          _c(
            "DsfVirtualScroll",
            [
              _c("div", { staticClass: "total" }, [
                _c("p", [
                  _vm._v(" 总题数： "),
                  _c("span", { staticClass: "test_total" }, [
                    _vm._v(" " + _vm._s(_vm.totalNum) + " "),
                  ]),
                  _vm._v("题 "),
                ]),
                _c("p", [
                  _vm._v(" 当前总分： "),
                  _c("span", { staticClass: "total_score" }, [
                    _vm._v(" " + _vm._s(_vm.totalScore) + " "),
                  ]),
                  _vm._v("分 "),
                ]),
              ]),
              _vm._l(_vm.exam.items, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item group_simple",
                    on: {
                      click: function ($event) {
                        return _vm.moveTo(index)
                      },
                    },
                  },
                  [
                    _c("h3", { staticClass: "test_tittle" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c("p", { staticClass: "left_p" }, [
                      _vm._v(" 共 "),
                      _c("span", { staticClass: "test_num" }, [
                        _vm._v(_vm._s(_vm.getTotalNum(item))),
                      ]),
                      _vm._v(" 题 ，共 "),
                      _c("span", { staticClass: "all_fraction" }, [
                        _vm._v(_vm._s(item.totalScore)),
                      ]),
                      _vm._v(" 分 "),
                    ]),
                    item.questionsItems.value === "input" && item.scoreMethod
                      ? _c(
                          "p",
                          { staticClass: "left_p" },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: {
                                  change: function ($event) {
                                    return _vm.changeInput(item)
                                  },
                                },
                                model: {
                                  value: item.scoreMethod.value,
                                  callback: function ($$v) {
                                    _vm.$set(item.scoreMethod, "value", $$v)
                                  },
                                  expression: "item.scoreMethod.value",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("按题计分"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("按空计分"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.scoreMethod.value === "1"
                      ? _c(
                          "p",
                          {
                            staticClass: "left_p",
                            staticStyle: { position: "relative" },
                          },
                          [
                            _vm._v(" 每题分数 "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.score,
                                  expression: "item.score",
                                },
                              ],
                              staticClass: "score",
                              attrs: { type: "text" },
                              domProps: { value: item.score },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(item, "score", $event.target.value)
                                  },
                                  function ($event) {
                                    return _vm.resetItemScore(item)
                                  },
                                ],
                              },
                            }),
                            _vm._v(" 分 "),
                            item.error
                              ? _c(
                                  "span",
                                  { staticClass: "el-form-item__error" },
                                  [_vm._v(_vm._s(item.message))]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    item.scoreMethod.value === "2"
                      ? _c("p", { staticClass: "left_p" }, [
                          _vm._v(" 每空分数 "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.optionsScore,
                                expression: "item.optionsScore",
                              },
                            ],
                            staticClass: "score",
                            attrs: { type: "text" },
                            domProps: { value: item.optionsScore },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item,
                                    "optionsScore",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  return _vm.changeInput(item)
                                },
                              ],
                            },
                          }),
                          _vm._v(" 分 "),
                        ])
                      : _vm._e(),
                    _c("p", { staticClass: "test_icon_a" }, [
                      _c(
                        "a",
                        {
                          staticClass: "content-icon",
                          on: {
                            click: function ($event) {
                              return _vm.deleteItem(
                                index,
                                _vm.exam.items,
                                _vm.exam,
                                $event
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "iconfont icon-icon_del" })]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "content-icon",
                          on: {
                            click: function ($event) {
                              return _vm.move(-1, index, _vm.exam.items, $event)
                            },
                          },
                        },
                        [_c("i", { staticClass: "iconfont icon-icon_up" })]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "content-icon",
                          on: {
                            click: function ($event) {
                              return _vm.move(1, index, _vm.exam.items, $event)
                            },
                          },
                        },
                        [_c("i", { staticClass: "iconfont icon-icon_down" })]
                      ),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { ref: "questionsBoard", staticClass: "questions-board" },
        [
          _c(
            "DsfVirtualScroll",
            [
              _vm._l(_vm.exam.items, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    ref: "question" + index,
                    refInFor: true,
                    staticClass: "group_simple",
                  },
                  [
                    _c(
                      "p",
                      { staticClass: "paper-name" },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: item.name,
                            callback: function ($$v) {
                              _vm.$set(item, "name", $$v)
                            },
                            expression: "item.name",
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(item.questionsItems.text))]),
                        _c(
                          "span",
                          {
                            staticClass: "add-question",
                            on: {
                              click: function ($event) {
                                return _vm.create(item.questionsItems, item)
                              },
                            },
                          },
                          [_vm._v("+ 添加试题")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "questions" },
                      [
                        item.questions && item.questions.length > 0
                          ? _vm._l(item.questions, function (question, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "question" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "left" },
                                    [
                                      _c("dsf-exam-item-box", {
                                        key: question.examQuestionsId,
                                        attrs: {
                                          readOnly: _vm.previewStatus,
                                          previewStatus: _vm.previewStatus,
                                          subjects: question,
                                          "exam-index": i,
                                          type: "practice",
                                          "hide-mark": true,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "right" }, [
                                    _c("div", { staticClass: "btns" }, [
                                      _c("a", { staticClass: "content-icon" }, [
                                        _c("i", {
                                          staticClass: "iconfont icon-icon_del",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteItem(
                                                i,
                                                item.questions,
                                                item,
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "content-icon iconfont",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-icon_up",
                                            on: {
                                              click: function ($event) {
                                                return _vm.move(
                                                  -1,
                                                  i,
                                                  item.questions,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "content-icon iconfont",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-icon_down",
                                            on: {
                                              click: function ($event) {
                                                return _vm.move(
                                                  1,
                                                  i,
                                                  item.questions,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "question-info" },
                                      [
                                        item.questionsItems.value === "input" &&
                                        question.scoreMethod
                                          ? _c(
                                              "p",
                                              { staticClass: "left_p" },
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.resetQuestionScore(
                                                          question,
                                                          item,
                                                          item
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        question.scoreMethod
                                                          .value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          question.scoreMethod,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "question.scoreMethod.value",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: "1" } },
                                                      [_vm._v("按题计分")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        staticClass: "has-tip",
                                                        attrs: { label: "2" },
                                                      },
                                                      [_vm._v("按空计分")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "example-score m-score",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.questionsItems.value ===
                                                    "group"
                                                    ? "总分数"
                                                    : "分 数"
                                                ) +
                                                " "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: question.score,
                                                  expression: "question.score",
                                                },
                                              ],
                                              staticClass: "score",
                                              domProps: {
                                                value: question.score,
                                              },
                                              on: {
                                                input: [
                                                  function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      question,
                                                      "score",
                                                      $event.target.value
                                                    )
                                                  },
                                                  function ($event) {
                                                    return _vm.resetQuestionScore(
                                                      question,
                                                      item,
                                                      item
                                                    )
                                                  },
                                                ],
                                              },
                                            }),
                                            _vm._v(" 分 "),
                                            question.error
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-form-item__error",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(question.message)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        item.questionsItems.value === "group"
                                          ? _vm._l(
                                              question.children,
                                              function (childValue, childKey) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      childValue.examQuestionsId,
                                                    staticClass: "left_p",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(childKey + 1) +
                                                        "题 "
                                                    ),
                                                    childValue.items.value ===
                                                      "input" &&
                                                    childValue.scoreMethod
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "left_p",
                                                          },
                                                          [
                                                            _c(
                                                              "el-radio-group",
                                                              {
                                                                model: {
                                                                  value:
                                                                    childValue
                                                                      .scoreMethod
                                                                      .value,
                                                                  callback: function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      childValue.scoreMethod,
                                                                      "value",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "childValue.scoreMethod.value",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-radio",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "1",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "按题计分"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-radio",
                                                                  {
                                                                    staticClass:
                                                                      "has-tip",
                                                                    attrs: {
                                                                      label:
                                                                        "2",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "按空计分"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "example-score m-score",
                                                      },
                                                      [
                                                        _vm._v(" 分 数 "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                childValue.score,
                                                              expression:
                                                                "childValue.score",
                                                            },
                                                          ],
                                                          staticClass: "score",
                                                          domProps: {
                                                            value:
                                                              childValue.score,
                                                          },
                                                          on: {
                                                            input: [
                                                              function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  childValue,
                                                                  "score",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.resetQuestionScore(
                                                                  childValue,
                                                                  question,
                                                                  item
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" 分 "),
                                                        childValue.error
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "el-form-item__error",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    childValue.message
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    childValue.scoreMethod &&
                                                    childValue.scoreMethod
                                                      .value == 2
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "muti-sel-score",
                                                          },
                                                          _vm._l(
                                                            childValue.options,
                                                            function (
                                                              option,
                                                              oIndex
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: oIndex,
                                                                  staticClass:
                                                                    "example-score",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sel_style",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "第" +
                                                                          _vm._s(
                                                                            oIndex +
                                                                              1
                                                                          ) +
                                                                          "空"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          option.score,
                                                                        expression:
                                                                          "option.score",
                                                                      },
                                                                    ],
                                                                    staticClass:
                                                                      "score",
                                                                    domProps: {
                                                                      value:
                                                                        option.score,
                                                                    },
                                                                    on: {
                                                                      input: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            option,
                                                                            "score",
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.resetQuestionOption(
                                                                            childValue,
                                                                            question,
                                                                            item
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    " 分 "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._e(),
                                                    _c("el-divider"),
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          : _vm._e(),
                                        question.scoreMethod &&
                                        question.scoreMethod.value == 2
                                          ? _c(
                                              "div",
                                              { staticClass: "muti-sel-score" },
                                              _vm._l(
                                                question.options,
                                                function (option, oIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: oIndex,
                                                      staticClass:
                                                        "example-score",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "sel_style",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "第" +
                                                              _vm._s(
                                                                oIndex + 1
                                                              ) +
                                                              "空"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: option.score,
                                                            expression:
                                                              "option.score",
                                                          },
                                                        ],
                                                        staticClass: "score",
                                                        domProps: {
                                                          value: option.score,
                                                        },
                                                        on: {
                                                          input: [
                                                            function ($event) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                option,
                                                                "score",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                            function ($event) {
                                                              return _vm.resetQuestionOption(
                                                                question,
                                                                item
                                                              )
                                                            },
                                                          ],
                                                        },
                                                      }),
                                                      _vm._v(" 分 "),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]
                              )
                            })
                          : _vm._e(),
                        item.settings && item.settings.length > 0
                          ? _vm._l(item.settings, function (setting, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "question" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "left" },
                                    [
                                      _c(
                                        "el-form",
                                        {
                                          ref: "form",
                                          refInFor: true,
                                          attrs: { "label-width": "80px" },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "tags",
                                              attrs: { label: "试题分类" },
                                            },
                                            [
                                              setting.questionsTypes
                                                ? _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          setting.questionsTypes
                                                            .text
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "tags",
                                              attrs: { label: "试题标签" },
                                            },
                                            _vm._l(
                                              setting.tags,
                                              function (Label, difIndex) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: difIndex,
                                                    staticClass: "tag",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(Label) + " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "难易程度" } },
                                            _vm._l(
                                              setting.difficulties,
                                              function (diff, difIndex) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: difIndex,
                                                    staticClass: "diff-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "difficulty",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              diff.difficulty
                                                                .text
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "diff-num",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              diff.questionsNum
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "p",
                                            [
                                              _c("el-radio", {
                                                staticClass: "random",
                                                attrs: {
                                                  label: "随机",
                                                  value: "随机",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "tip" },
                                                [
                                                  _vm._v(
                                                    "（每位学员试题不一致）"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "right" }, [
                                    _c("div", { staticClass: "btns" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "content-icon",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editItem(
                                                item,
                                                setting,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "iconfont icon-edit",
                                          }),
                                        ]
                                      ),
                                      _c("a", { staticClass: "content-icon" }, [
                                        _c("i", {
                                          staticClass: "iconfont icon-icon_del",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteItem(
                                                i,
                                                item.settings,
                                                item,
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "content-icon iconfont",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-icon_up",
                                            on: {
                                              click: function ($event) {
                                                return _vm.move(
                                                  -1,
                                                  i,
                                                  item.settings,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "content-icon iconfont",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-icon_down",
                                            on: {
                                              click: function ($event) {
                                                return _vm.move(
                                                  1,
                                                  i,
                                                  item.settings,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "question-info" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "example-score m-score",
                                          },
                                          [
                                            _vm._v(" 分 数 "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: setting.score,
                                                  expression: "setting.score",
                                                },
                                              ],
                                              staticClass: "score",
                                              domProps: {
                                                value: setting.score,
                                              },
                                              on: {
                                                input: [
                                                  function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      setting,
                                                      "score",
                                                      $event.target.value
                                                    )
                                                  },
                                                  function ($event) {
                                                    return _vm.resetSettingScore(
                                                      setting,
                                                      item
                                                    )
                                                  },
                                                ],
                                              },
                                            }),
                                            _vm._v(" 分 "),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            })
                          : _vm._e(),
                        [
                          item.questions.length === 0 &&
                          item.settings.length === 0
                            ? _c("div", { staticClass: "empty" }, [
                                _vm._v(" 此大题还未添加试题，请点击 "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "add-question",
                                    on: {
                                      click: function ($event) {
                                        return _vm.create(
                                          item.questionsItems,
                                          item
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" +添加试题 ")]
                                ),
                                _vm._v(" 按钮选择试题 "),
                              ])
                            : _vm._e(),
                        ],
                      ],
                      2
                    ),
                  ]
                )
              }),
              _c("div", { staticClass: "ipt-questions-box" }, [
                _c("div", { staticClass: "create_q_contain" }, [
                  _c("div", { staticClass: "create_q_group_icon" }, [
                    _c("span", [_vm._v("+")]),
                  ]),
                  _c("br"),
                  _c("span", { staticClass: "create_q_group_text" }, [
                    _vm._v("创建新的大题"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "create_q_contain question-btns" },
                  _vm._l(_vm.questionTypes, function (type, index) {
                    return _c(
                      "button",
                      {
                        key: index,
                        staticClass: "q_type_btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.create(type)
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(type.text))])]
                    )
                  }),
                  0
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }